import { inject, type InjectionKey } from 'vue'

export interface TenantUsersModalsContext {
  showAddTenantUser: () => void
}

export const tenantUsersModalsKey = Symbol(
  'tenant-users-modals'
) as InjectionKey<TenantUsersModalsContext>

export function useTenantUsersModals() {
  return inject(tenantUsersModalsKey)
}
